import { render, staticRenderFns } from "./DonateDialog.vue?vue&type=template&id=453c41e8&"
import script from "./DonateDialog.vue?vue&type=script&lang=js&"
export * from "./DonateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports